import Vue from 'vue'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
const bugsnagClient = bugsnag({"environment":"production","appVersion":"1.0.0","apiKey":"45b65f6111b630fb270e05b7b483e7a6"})
bugsnagClient.use(bugsnagVue, Vue)

export default function ({ app }, inject) {
  inject('bugsnag', bugsnagClient)
}
